<template>
	<div ref="popupContainer">
		<vs-popup
			:title="societyName + ', Contrat N°' + contractId + ' : ' + productName"
			:active.sync="showDocPopup"
		>
			<ShareLinkPopup
				v-model="showDocPopup"
				:apiUrl="apiUrl"
				:society_id="societyId"
				:mission_id="missionId"
				:task_id="taskId"
				:contract_id="contractId"
				@open-confirmation="confirmation(arguments)"
				ref="shareLink"
			/>
		</vs-popup>
		<vs-popup
			:active.sync="showLinkEditPopup"
			:title="
				society_name
					? 'Modification d\'un Netlink: ' +
					  society_name +
					  '(' +
					  provider_name +
					  ')'
					: 'Modification d\'un Netlink'
			"
		>
			<div class="vx-row">
				<div class="vx-col sm:w-1/3 w-full" style="white-space: nowrap">
					<label for="" class="vs-select--label">Lien acheté</label>
					<div class="flex">
						<vs-input
							class="w-full"
							placeholder="Lien acheté"
							v-model="modifiedNetlink.url_bought"
							:style="styleValidator('url_bought')"
							@change="validateOne(modifiedNetlink.url_bought, 'url_bought')"
						/>
						<vx-tooltip
							v-if="
								validators['url_bought'] &&
								validators['url_bought'].errText !== ''
							"
							:text="errText('url_bought')"
							class="ml-3"
							style="display: inline-block"
						>
							<vs-icon icon="error" size="medium" style="color: red"></vs-icon>
						</vx-tooltip>
					</div>
				</div>
				<div class="vx-col sm:w-1/3 w-full" style="white-space: nowrap">
					<label for="" class="vs-select--label">Landing page</label>
					<div class="flex">
						<vs-input
							class="w-full"
							placeholder="Landing page"
							v-model="modifiedNetlink.landing_page"
							:style="styleValidator('landing_page')"
							@change="
								validateOne(modifiedNetlink.landing_page, 'landing_page')
							"
						/>
						<vx-tooltip
							v-if="
								validators['landing_page'] &&
								validators['landing_page'].errText !== ''
							"
							:text="errText('landing_page')"
							class="ml-3"
							style="display: inline-block"
						>
							<vs-icon icon="error" size="medium" style="color: red"></vs-icon>
						</vx-tooltip>
					</div>
				</div>
				<div class="vx-col sm:w-1/3 w-full" style="white-space: nowrap">
					<label for="" class="vs-select--label">Statut</label>
					<div class="flex">
						<vs-select
							autocomplete
							v-model="modifiedNetlink.status"
							class="w-full select-medium mr-2"
							placeholder="Statut"
							:style="styleValidator('status')"
							@change="validateOne(modifiedNetlink.status, 'status')"
						>
							<vs-select-item
								:key="index"
								:value="item.value"
								:text="item.text"
								v-for="(item, index) in netlinkStatus"
								class="w-full"
							/>
						</vs-select>
						<vx-tooltip
							v-if="validators['status'] && validators['status'].errText !== ''"
							:text="errText('status')"
							class="ml-3"
							style="display: inline-block"
						>
							<vs-icon icon="error" size="medium" style="color: red"></vs-icon>
						</vx-tooltip>
					</div>
				</div>
			</div>
			<div class="vx-row mt-2">
				<div class="vx-col sm:w-1/3 w-full" style="white-space: nowrap">
					<label for="" class="vs-select--label">Type ancre</label>
					<div class="flex">
						<vs-select
							autocomplete
							v-model="modifiedNetlink.anchor_type"
							class="w-full select-medium mr-2"
							placeholder="Type ancre"
							:style="styleValidator('anchor_type')"
							@change="validateOne(modifiedNetlink.anchor_type, 'anchor_type')"
						>
							<vs-select-item
								:key="index"
								:value="item.value"
								:text="item.text"
								v-for="(item, index) in anchorTypes"
								class="w-full"
							/>
						</vs-select>
						<vx-tooltip
							v-if="
								validators['anchor_type'] &&
								validators['anchor_type'].errText !== ''
							"
							:text="errText('anchor_type')"
							class="ml-3"
							style="display: inline-block"
						>
							<vs-icon icon="error" size="medium" style="color: red"></vs-icon>
						</vx-tooltip>
					</div>
				</div>
				<div class="vx-col sm:w-1/3 w-full" style="white-space: nowrap">
					<label for="" class="vs-select--label">Type lien</label>
					<div class="flex">
						<vs-select
							autocomplete
							v-model="modifiedNetlink.link_type"
							class="w-full select-medium mr-2"
							placeholder="Type lien"
							:style="styleValidator('link_type')"
							@change="validateOne(modifiedNetlink.link_type, 'link_type')"
						>
							<vs-select-item
								:key="index"
								:value="item.id"
								:text="item.name"
								v-for="(item, index) in netlink_types"
								class="w-full"
							/>
						</vs-select>
						<vx-tooltip
							v-if="
								validators['link_type'] &&
								validators['link_type'].errText !== ''
							"
							:text="errText('link_type')"
							class="ml-3"
							style="display: inline-block"
						>
							<vs-icon icon="error" size="medium" style="color: red"></vs-icon>
						</vx-tooltip>
					</div>
				</div>
				<div
					v-if="modifiedNetlink"
					class="vx-col sm:w-1/3 w-full"
					style="white-space: nowrap"
				>
					<label for="" class="vs-select--label">Prix</label>
					<div class="flex">
						<vs-input
							class="w-full"
							v-model="modifiedNetlink.price"
							:style="styleValidator('price')"
							@change="validateOne(modifiedNetlink.price, 'price')"
						/>
						<vx-tooltip
							v-if="validators['price'] && validators['price'].errText !== ''"
							:text="errText('price')"
							class="ml-3"
							style="display: inline-block"
						>
							<vs-icon icon="error" size="medium" style="color: red"></vs-icon>
						</vx-tooltip>
					</div>
				</div>
				<div
					v-if="isRecurringLink(modifiedNetlink.link_type)"
					class="vx-col sm:w-1/3 w-full"
					style="white-space: nowrap !important"
				>
					<label for="" class="vs-select--label">Renouvellement</label>
					<div class="flex">
						<vs-select
							autocomplete
							v-model="modifiedNetlink.renew_duration"
							class="w-full select-medium mr-2"
							:style="styleValidator('renew_duration')"
							@change="
								validateOne(modifiedNetlink.renew_duration, 'renew_duration')
							"
						>
							<vs-select-item
								:key="index"
								:value="item.value"
								:text="item.text"
								v-for="(item, index) in renewDurations"
								class="w-full"
							/>
						</vs-select>
						<vx-tooltip
							v-if="
								validators['renew_duration'] &&
								validators['renew_duration'].errText !== ''
							"
							:text="errText('renew_duration')"
							class="ml-3"
							style="display: inline-block"
						>
							<vs-icon icon="error" size="medium" style="color: red"></vs-icon>
						</vx-tooltip>
					</div>
				</div>
				<div class="vx-col sm:w-1/3 w-full">
					<vs-button color="primary" class="mt-2" @click="saveModifiedNetlink()"
						>Enregistrer Netlink</vs-button
					>
				</div>
			</div>
		</vs-popup>
		<br />
		<h6 class="th-sticky" style="color: #a9a9a9">
			Résultat total: {{ rowNum }} / {{ allContracts.length }}
		</h6>
		<br />
		<div v-if="isLoading" style="text-align: center"><p>Chargement ...</p></div>
		<vs-table
			v-else
			auto-resize
			pagination
			max-items="25"
			:data="allContracts"
			:key="refreshKey"
			id="tb-gestion-netlink"
			noDataText="Aucun netlink trouvé"
		>
			<template slot="thead">
				<vs-th class="th-sticky" style="width: 40px"></vs-th>
				<vs-th class="th-sticky">Contrat<br />n°</vs-th>
				<vs-th class="th-sticky" style="padding-left: 43px">Client</vs-th>
				<vs-th class="th-sticky pdl0"
					><div class="w-full text-center" style="text-transform: uppercase">
						Thématique
					</div></vs-th
				>
				<vs-th class="th-sticky pdl0">Type</vs-th>
				<vs-th class="th-sticky"
					><div class="w-full text-center" style="text-transform: uppercase">
						Commercial
					</div></vs-th
				>
				<vs-th class="th-sticky"
					><div class="w-full text-center" style="text-transform: uppercase">
						Consultant<br />Lead
					</div></vs-th
				>
				<vs-th class="th-sticky pdl0"
					><div class="w-full text-center" style="text-transform: uppercase">
						Statut
					</div></vs-th
				>
				<vs-th
					sort-key="total_max_budget_netlink"
					class="th-sticky"
					style="pointer-events: auto"
					><span class="w-full text-right">Budget Max<br />Total</span></vs-th
				>
				<vs-th
					sort-key="total_spent_budget_netlink"
					class="th-sticky"
					style="pointer-events: auto"
					><span class="w-full text-right">Budget<br />dépensé</span></vs-th
				>
			</template>

			<template slot-scope="{ data }">
				<vs-tr
					:key="index"
					v-for="(contract, index) in data"
					class="getWidth"
					ref="switch"
				>
					<div v-show="false">
						{{ (rowNum = data.length) }}
					</div>
					<vs-td
						class="text-center"
						style="width: 40px; cursor: pointer"
						@click="toggleExpand(index)"
					>
						<i
							:class="
								expandedRows[index]
									? 'feather icon-chevron-down'
									: 'feather icon-chevron-right'
							"
						></i>
					</vs-td>
					<vs-td :data="data[index].id"
						><span
							@click.stop="event.stopPropagation()"
							@click="displayContractPopup(contract.id)"
							class="hvr-underline hvr-underline-out"
							>{{ contract.id }}</span
						></vs-td
					>
					<vs-td :data="data[index].society_name" class="text-center">
						<vx-tooltip
							:text="getSocietyName(contract.society_id)"
							position="top"
							style="display: flex; align-items: center; text-align: left"
						>
							<vs-avatar
								style="border: 1px solid; flex-shrink: 0"
								:text="getSocietyName(contract.society_id)"
								:src="setSocietyImage(contract.society_id)"
								@click.stop="event.stopPropagation()"
								@click="displaySocietyPopup(contract.society_id)"
							/>
							<div>{{ getSocietyName(contract.society_id) }}</div>
						</vx-tooltip>
					</vs-td>
					<vs-td class="text-center">
						<div
							v-for="tag in data[index].tags"
							:key="tag.tag_name"
							style="
								background-color: rgb(8, 176, 185);
								border-radius: 10px;
								color: white;
								padding: 5px;
								text-align: center;
								display: inline-block;
								font-size: 10px;
								margin: 3px;
							"
						>
							{{ tag.tag_name }}
						</div>
					</vs-td>
					<vs-td :data="data[index].type">{{
						data[index].type == 1 ? "Mensuel" : "One Shot"
					}}</vs-td>
					<vs-td
						:data="data[index].commercial_id"
						v-if="data[index].commercial_id"
						class="pdl0"
					>
						<div class="flex center" style="justify-content: center">
							<div class="flex center" style="justify-content: center">
								<vx-tooltip :text="contract.commercial_name" position="top">
									<vs-avatar
										style="border: 1px solid"
										:text="getCollaboratorName(contract.commercial_id)"
										:src="getCollaboratorAvatar(contract.commercial_id)"
									/>
								</vx-tooltip>
							</div>
						</div>
					</vs-td>
					<vs-td v-else> </vs-td>
					<vs-td
						:data="data[index].manager_id"
						v-if="data[index].manager_id"
						class="pdl0"
					>
						<div class="flex center" style="justify-content: center">
							<vx-tooltip :text="data[index].manager_name" position="top">
								<vs-avatar
									style="border: 1px solid"
									:text="data[index].manager_name"
									:src="getCollaboratorAvatar(data[index].manager_id)"
								/>
							</vx-tooltip>
						</div>
					</vs-td>
					<vs-td v-else> </vs-td>
					<vs-td
						:data="contract.status"
						style="padding-left: 10px; width: 100px"
					>
						<vs-chip
							style="width: 80px; margin-top: 2px"
							:color="getContractStatusColor(contract.status)"
						>
							{{ getContractStatus(contract.status) }}
						</vs-chip>
					</vs-td>
					<vs-td
						:data="data[index]"
						class="text-right pdl0"
						style="padding-right: 11px"
						>{{
							convertInternationalNumberToFrenchCurrency(
								getTotalBudgetMax(data[index])
							)
						}}</vs-td
					>
					<vs-td
						:data="data[index].id"
						class="text-right pdl0"
						style="padding-right: 11px"
						><span
							:style="
								setBudgetColor([
									Number(getTotalBudgetMax(data[index])),
									contract.missions.reduce(
										(sum, e) => sum + e.mission_spent_budget_netlink,
										0
									),
								])
							"
							>{{
								convertInternationalNumberToFrenchCurrency(
									contract.missions.reduce(
										(sum, e) => sum + e.mission_spent_budget_netlink,
										0
									)
								)
							}}</span
						></vs-td
					>

					<!--<vs-td :data="data[index].id">
						<div style="display: flex; justify-content: space-evenly;" @click.stop="event.stopPropagation()">
							<vs-button @click="displayLinkPopup(contract.contract_id, contract.society_name)" style="width: 180px !important; white-space: nowrap;">Liens en attente <span v-if="contract.waiting_netlink_count > 0" style="border-radius: 5px; background-color: rgb(140, 23, 164); color: white;" class="px-2 ml-1">{{ contract.waiting_netlink_count }}</span></vs-button>
							<vs-button @click="displayNewPurchasePopup(contract)" icon-pack="feather" icon="icon-plus-circle" class="btn-txt-center">
								Netlink
							</vs-button>
						</div>
					</vs-td>-->
					<vs-table
						:data="contract.missions"
						auto-resize
						class="w-full thead-1"
					>
						<template slot="thead">
							<vs-th class="bgcolor white-txt pdl0">PRESTATIONS</vs-th>
							<vs-th class="bgcolor white-txt pdl0">COMMENTAIRES</vs-th>
							<vs-th class="bgcolor white-txt"
								><div class="w-full text-center">CONSULTANT(S)</div></vs-th
							>
							<vs-th class="bgcolor white-txt pdl0">RÉCURRENCE</vs-th>
							<vs-th class="bgcolor white-txt"
								><div class="w-full text-right">BUDGET</div></vs-th
							>
							<vs-th class="bgcolor white-txt"
								><div class="w-full text-right">BUDGET<br />RESTANT</div></vs-th
							>
							<vs-th class="bgcolor white-txt"
								><div class="w-full text-right">BUDGET<br />DÉPENSÉ</div></vs-th
							>
							<vs-th class="bgcolor white-txt"
								><div class="w-full text-right">DÉBUT</div></vs-th
							>
							<vs-th class="bgcolor white-txt"
								><div class="w-full text-right">FIN</div></vs-th
							>
							<vs-th class="bgcolor white-txt pdl0"
								><div style="text-align: center; width: 100%">
									STATUT
								</div></vs-th
							>
							<vs-th class="bgcolor white-txt pdl0" v-if="selectedDate"
								><div class="w-full text-center">TÂCHE</div></vs-th
							>
							<vs-th></vs-th>
						</template>
						<template slot-scope="{ data }">
							<vs-tr
								:key="index1"
								v-for="(mission, index1) in data"
								:ref="'switchMission' + contract.id"
							>
								<vs-td style="font-weight: 700">{{ mission.name }}</vs-td>
								<vs-td class="fw-bold commentary">{{
									mission.commentary
								}}</vs-td>
								<vs-td class="pdl0">
									<div style="display: flex; justify-content: center">
										<div
											class="vx-row center-content"
											v-if="mission.missions_users"
										>
											<div
												class="flex center"
												v-for="(user, indexx) in mission.missions_users"
												:key="indexx"
											>
												<vx-tooltip
													:text="
														user.firstname.replace(/^\S/, (s) =>
															s.toUpperCase()
														) +
														' ' +
														user.lastname.toUpperCase()
													"
													position="top"
												>
													<vs-avatar
														style="border: 1px solid"
														:text="
															user.firstname.substr(0, 1).toUpperCase() +
															user.lastname.substr(0, 1).toUpperCase()
														"
														:src="getCollaboratorAvatar(user.id)"
													/>
												</vx-tooltip>
											</div>
										</div>
									</div>
								</vs-td>
								<vs-td>
									{{ mission.recurrence == 1 ? "Mensuel" : "One Shot" }}
								</vs-td>
								<vs-td class="text-right" style="padding-right: 14px">{{
									mission.max_budget
										? convertInternationalNumberToFrenchCurrency(
												mission.max_budget
										  )
										: ""
								}}</vs-td>
								<vs-td class="text-right" style="padding-right: 14px">{{
									mission.max_budget
										? convertInternationalNumberToFrenchCurrency(
												mission.max_budget -
													mission.mission_spent_budget_netlink
										  )
										: ""
								}}</vs-td>
								<vs-td
									class="text-right"
									style="
										padding-right: 14px;
										font-weight: 700;
										white-space: nowrap;
									"
									>{{
										mission.mission_spent_budget_netlink
											? convertInternationalNumberToFrenchCurrency(
													mission.mission_spent_budget_netlink
											  )
											: ""
									}}</vs-td
								>
								<vs-td class="text-right" style="padding-right: 14px">{{
									getDateToFrenchFormat(mission.start_date)
								}}</vs-td>
								<vs-td class="text-right" style="padding-right: 14px">{{
									getDateToFrenchFormat(mission.estimated_end_date)
								}}</vs-td>

								<!-- <vs-td>{{ row.time_limit ? row.time_limit + "h" : " " }}</vs-td> -->
								<vs-td class="pdl0">
									<div class="flex center" style="padding-top: 3px">
										<vs-chip
											style="
												width: 80px;
												margin-left: 10px;
												border-radius: 6px;
												padding-top: 2px;
											"
											:color="getContractStatusColor(mission.status)"
											>{{ getContractStatus(mission.status) }}</vs-chip
										>
									</div>
								</vs-td>
								<vs-td v-if="selectedDate" class="pdl0 text-center">
									<Slider
										v-if="
											mission.tasks.find(
												(t) =>
													t.creation_date.substr(0, 7) ==
													selectedDate.split('/').reverse().join('-')
											)
										"
										v-model="
											mission.tasks.find(
												(t) =>
													t.creation_date.substr(0, 7) ==
													selectedDate.split('/').reverse().join('-')
											).archivate
										"
										:id1="
											mission.tasks.find(
												(t) =>
													t.creation_date.substr(0, 7) ==
													selectedDate.split('/').reverse().join('-')
											).id + 'off'
										"
										:id2="
											mission.tasks.find(
												(t) =>
													t.creation_date.substr(0, 7) ==
													selectedDate.split('/').reverse().join('-')
											).id + 'null'
										"
										:id3="
											mission.tasks.find(
												(t) =>
													t.creation_date.substr(0, 7) ==
													selectedDate.split('/').reverse().join('-')
											).id + 'on'
										"
										styleSld="font-size: 10px; background-color: rgba(224, 224, 224, 0.78);width: 165px;"
										styleOp1="color: black; background-color: #FF0000; width:55px; padding: 5px 10px;"
										styleOp2="color: black; background-color: #FFA800; width:55px; padding: 5px 10px;"
										styleOp3="color: black; background-color: #28C76F; width:55px; padding: 5px 10px;"
										styleDefault="color: black;"
										option1="Annulé"
										option2="À faire"
										option3="Fait"
										@btn-selected="
											updateTask(
												mission.tasks.find(
													(t) =>
														t.creation_date.substr(0, 7) ==
														selectedDate.split('/').reverse().join('-')
												),
												$event
											)
										"
									/>
									<span v-else>Pas de tâche pour ce mois</span>
								</vs-td>
								<!-- <vs-td style="width: 50px;" class="pdl0">
											<vx-tooltip text="Ajouter un netlink" position="top">
												<vs-button
													@click.stop="event.stopPropagation()"
													@click="resetNewNetlink(mission.addMode, mission); mission.addMode = true; $refs['switchMission'+ contract.id][index1].expanded ? refreshAddLine(contract.id, index1, 2) : refreshAddLine(contract.id, index1, 3);"
													size="large"
													color="primary"
													type="flat"
													icon-pack="feather"
													icon="icon-plus-circle"
												></vs-button>
											</vx-tooltip>
										</vs-td> -->
								<template slot="expand">
									<div class="vx-row" style="width: inherit">
										<vs-tr
											v-if="mission.addMode"
											class="w-full flex"
											style="
												justify-content: space-around;
												align-items: center;
												flex-flow: wrap;
											"
										>
											<vs-td
												style="
													text-align: center;
													width: 100%;
													max-width: 150px;
												"
												class="pdl0"
											>
												<vs-select
													v-model="mission.provider_id"
													class="w-full select-medium mr-2"
													placeholder="Prestataire"
												>
													<vs-select-item
														:key="index"
														:value="item.id"
														:text="item.society"
														v-for="(item, index) in netlinkProviders"
														class="w-full"
													/>
												</vs-select>
											</vs-td>
											<vs-td class="pdl0">
												<vs-input
													v-model="mission.url_bought"
													placeholder="Lien acheté"
													@change="refreshAddLine(contract.id, index1, 2)"
												/>
											</vs-td>
											<vs-td class="pdl0">
												<vs-input
													v-model="mission.landing_page"
													placeholder="Landing page"
													@change="refreshAddLine(contract.id, index1, 2)"
												/>
											</vs-td>
											<vs-td style="max-width: 100px" class="w-full pdl0">
												<vs-select
													placeholder="Type Ancre"
													v-model="mission.anchor_type"
													class="w-full select-medium mr-2"
												>
													<vs-select-item
														:key="index"
														:value="item.value"
														:text="item.text"
														v-for="(item, index) in anchorTypes"
														class="w-full"
													/>
												</vs-select>
											</vs-td>
											<vs-td style="max-width: 100px" class="w-full pdl0">
												<vs-select
													placeholder="Type Lien"
													v-model="mission.link_type"
													class="w-full select-medium mr-2"
												>
													<vs-select-item
														:key="index"
														:value="item.id"
														:text="item.name"
														v-for="(item, index) in netlink_types.filter(
															(row) => row.is_dns == 0
														)"
														class="w-full"
													/>
												</vs-select>
											</vs-td>

											<vs-td class="text-right pdl0">
												<vs-input
													placeholder="Prix"
													v-model="mission.netlink_price"
													style="width: 90px"
													@change="refreshAddLine(contract.id, index1, 2)"
												/>
											</vs-td>

											<vs-td class="pdl0" style="max-width: 120px">
												<vs-select
													v-model="mission.renew_duration"
													class="w-full select-medium mr-2"
													placeholder="Renouvellement"
												>
													<vs-select-item
														:key="index"
														:value="item.value"
														:text="item.text"
														v-for="(item, index) in renewDurations"
														class="w-full"
													/>
												</vs-select>
											</vs-td>

											<vs-td
												style="text-align: center; width: 100px"
												class="pdl0"
											>
												<vs-select
													placeholder="Statut"
													v-model="mission.netlink_status"
													class="w-full select-medium mr-2"
												>
													<vs-select-item
														:key="index"
														:value="item.value"
														:text="item.text"
														v-for="(item, index) in netlinkStatus"
														class="w-full"
													/>
												</vs-select>
											</vs-td>

											<vs-td class="pdl0">
												<vx-input-group class="bottom">
													<flat-pickr
														placeholder="Période"
														id="flatpickr"
														v-model="mission.period_date"
														:config="configDatePicker"
														style="width: 80px; text-align: center"
														@keydown.native.delete.capture.stop.prevent
													/>
												</vx-input-group>
											</vs-td>

											<vs-td class="pdl0" style="max-width: 100px">
												<vs-select
													v-model="mission.is_billable"
													class="w-full select-medium mr-2"
													placeholder="Facturable"
												>
													<vs-select-item
														:key="index"
														:value="item.value"
														:text="item.text"
														v-for="(item, index) in billableOptions"
														class="w-full"
													/>
												</vs-select>
											</vs-td>

											<vs-td class="pdl0 text-right" style="max-width: 120px">
												<vs-input
													class="w-full"
													v-model="mission.sell_price"
													placeholder="Prix de vente"
													@change="refreshAddLine(contract.id, index1, 2)"
												/>
											</vs-td>

											<vs-td style="width: 50px" class="pdl0">
												<vx-tooltip text="Valider" position="top">
													<vs-button
														@click="
															validateNetlink(
																contract.society_id,
																contract.id,
																mission
															)
														"
														size="large"
														color="primary"
														type="flat"
														icon-pack="feather"
														icon="icon-save"
													></vs-button>
												</vx-tooltip>
											</vs-td>
										</vs-tr>
										<vs-table
											:data="mission.netlinks"
											class="w-full thead-2"
											noDataText="Aucun netlink trouvé."
										>
											<template slot="thead">
												<vs-th sort-key="url_bought">Lien acheté</vs-th>
												<vs-th sort-key="landing_page" class="pdl0"
													>Landing page</vs-th
												>
												<vs-th sort-key="anchor_type" class="pdl0"
													>Type Ancre</vs-th
												>
												<vs-th sort-key="link_type" class="pdl0"
													>Type Lien</vs-th
												>
												<vs-th sort-key="netlink_price"
													><div class="w-full text-right">ACHAT</div></vs-th
												>
												<vs-th sort-key="creation_date" class="pdl0"
													><div class="w-full text-center">
														DATE<br />CRÉATION
													</div></vs-th
												>
												<vs-th sort-key="status"
													><div class="w-full text-center">STATUT</div></vs-th
												>
												<vs-th></vs-th>
											</template>
											<template slot-scope="{ data }">
												<vs-tr
													:key="index2 + refreshNetlink"
													v-for="(oneNetlink, index2) in data"
													:id="oneNetlink.id"
												>
													<vs-td
														:data="oneNetlink.url_bought"
														v-if="!oneNetlink.edit"
														><a
															class="hvr-underline hvr-underline-out"
															:href="oneNetlink.url_bought"
															target="_blank"
															>{{ oneNetlink.url_bought }}</a
														></vs-td
													>
													<vs-td :data="oneNetlink.url_bought" v-else>
														<vs-input
															v-model="oneNetlink.url_bought"
															@change="validateNetlinkInline(oneNetlink)"
														/>
													</vs-td>

													<vs-td
														:data="oneNetlink.landing_page"
														v-if="!oneNetlink.edit"
													>
														<a
															class="hvr-underline hvr-underline-out"
															:href="oneNetlink.landing_page"
															target="_blank"
															>{{ oneNetlink.landing_page }}</a
														>
													</vs-td>
													<vs-td :data="oneNetlink.landing_page" v-else>
														<vs-input
															v-model="oneNetlink.landing_page"
															@change="validateNetlinkInline(oneNetlink)"
														/>
													</vs-td>

													<vs-td
														:data="oneNetlink.anchor_type"
														v-if="!oneNetlink.edit"
														>{{
															getNetlinkAnchorType(oneNetlink.anchor_type)
														}}</vs-td
													>
													<vs-td
														:data="oneNetlink.anchor_type"
														v-else
														style="min-width: 100px"
													>
														<vs-select
															v-model="oneNetlink.anchor_type"
															class="w-full select-medium mr-2"
														>
															<vs-select-item
																:key="index"
																:value="item.value"
																:text="item.text"
																v-for="(item, index) in anchorTypes"
																class="w-full"
															/>
														</vs-select>
													</vs-td>

													<vs-td
														:data="oneNetlink.link_type"
														v-if="!oneNetlink.edit"
														>{{
															getNetlinkTypeName(oneNetlink.link_type)
														}}</vs-td
													>
													<vs-td
														:data="oneNetlink.link_type"
														v-else
														style="min-width: 100px"
													>
														<vs-select
															v-model="oneNetlink.link_type"
															class="w-full select-medium mr-2"
														>
															<vs-select-item
																:key="index"
																:value="item.id"
																:text="item.name"
																v-for="(item, index) in netlink_types.filter(
																	(row) => row.is_dns == 0
																)"
																class="w-full"
															/>
														</vs-select>
													</vs-td>

													<vs-td
														:data="oneNetlink.netlink_price"
														v-if="!oneNetlink.edit"
														class="pdl0 text-right"
														style="padding-right: 10px"
														>{{
															convertInternationalNumberToFrenchCurrency(
																oneNetlink.netlink_price
															)
														}}</vs-td
													>
													<vs-td :data="oneNetlink.netlink_price" v-else>
														<vs-input
															v-model="oneNetlink.netlink_price"
															@change="validateNetlinkInline(oneNetlink)"
															style="max-width: 100px"
														/>
													</vs-td>

													<vs-td
														:data="oneNetlink.creation_date"
														class="pdl0 text-center"
													>
														{{
															oneNetlink.creation_date
																? getDateToFrenchFormat(
																		oneNetlink.creation_date.substring(0, 10)
																  )
																: getDateToFrenchFormat(
																		getPurchaseIdToPurchaseDate(
																			oneNetlink.purchase_id
																		)
																  )
														}}</vs-td
													>

													<vs-td
														:data="oneNetlink.status"
														v-if="
															!oneNetlink.edit ||
															(oneNetlink.edit && oneNetlink.status == 0)
														"
														style="text-align: center; width: 80px"
														class="pdl0"
													>
														<vs-chip
															style="width: 80px"
															:color="
																getNetlinkStatusColor(String(oneNetlink.status))
															"
															class="ml-2"
															>{{
																getNetlinkStatus(String(oneNetlink.status))
															}}</vs-chip
														>
													</vs-td>
													<vs-td
														:data="oneNetlink.status"
														v-if="oneNetlink.edit && oneNetlink.status != 0"
														style="text-align: center; width: 100px"
														class="pdl0"
													>
														<vs-select
															v-model="oneNetlink.status"
															class="w-full select-medium mr-2"
														>
															<vs-select-item
																:key="index"
																:value="item.value"
																:text="item.text"
																v-for="(item, index) in netlinkStatus"
																class="w-full"
															/>
														</vs-select>
													</vs-td>

													<vs-td
														style="width: 50px"
														:data="oneNetlink"
														class="pdl0"
													>
														<vx-tooltip text="Modifier" position="top">
															<vs-button
																v-if="!oneNetlink.edit"
																@click="
																	oneNetlink.edit = true;
																	oneNetlink.tmpUrlBought =
																		oneNetlink.url_bought;
																	oneNetlink.tmpLandingPage =
																		oneNetlink.landing_page;
																	refreshNetlink++;
																"
																size="large"
																color="primary"
																type="flat"
																icon-pack="feather"
																icon="icon-edit-2"
															></vs-button>
														</vx-tooltip>
														<vx-tooltip text="Verrouiller" position="top">
															<vs-button
																v-if="oneNetlink.edit"
																@click="updateNetlinkInline(oneNetlink)"
																size="large"
																color="primary"
																type="flat"
																icon-pack="feather"
																icon="icon-save"
															></vs-button>
														</vx-tooltip>
													</vs-td>
												</vs-tr>
											</template>
										</vs-table>
									</div>
								</template>
							</vs-tr>
						</template>
					</vs-table>
				</vs-tr>
				<tr
					v-if="expandedRows[index]"
					:key="'expand-' + index"
					class="expand-row"
				>
					<td colspan="10">
						<div class="vx-row w-full">
							<vs-table
								:data="contract.missions"
								auto-resize
								class="w-full thead-1"
							>
								<template slot="thead">
									<vs-th class="bgcolor white-txt" style="width: 40px"></vs-th>
									<vs-th class="bgcolor white-txt pdl0">PRESTATIONS</vs-th>
									<vs-th class="bgcolor white-txt pdl0">COMMENTAIRES</vs-th>
									<vs-th class="bgcolor white-txt"
										><div class="w-full text-center">CONSULTANT(S)</div></vs-th
									>
									<vs-th class="bgcolor white-txt pdl0">RÉCURRENCE</vs-th>
									<vs-th class="bgcolor white-txt"
										><div class="w-full text-right">BUDGET</div></vs-th
									>
									<vs-th class="bgcolor white-txt"
										><div class="w-full text-right">
											BUDGET<br />RESTANT
										</div></vs-th
									>
									<vs-th class="bgcolor white-txt"
										><div class="w-full text-right">
											BUDGET<br />DÉPENSÉ
										</div></vs-th
									>
									<vs-th class="bgcolor white-txt"
										><div class="w-full text-right">DÉBUT</div></vs-th
									>
									<vs-th class="bgcolor white-txt"
										><div class="w-full text-right">FIN</div></vs-th
									>
									<vs-th class="bgcolor white-txt pdl0"
										><div style="text-align: center; width: 100%">
											STATUT
										</div></vs-th
									>
									<vs-th class="bgcolor white-txt pdl0" v-if="selectedDate"
										><div class="w-full text-center">TÂCHE</div></vs-th
									>
									<vs-th></vs-th>
								</template>
								<template slot-scope="{ data }">
									<vs-tr
										:key="index1"
										v-for="(mission, index1) in data"
										:ref="'switchMission' + contract.id"
									>
										<vs-td
											class="text-center"
											style="width: 40px; cursor: pointer"
											@click="toggleMissionExpand(index, index1)"
										>
											<i
												:class="
													expandedMissions[index + '-' + index1]
														? 'feather icon-chevron-down'
														: 'feather icon-chevron-right'
												"
											></i>
										</vs-td>
										<vs-td style="font-weight: 700">{{ mission.name }}</vs-td>
										<vs-td class="fw-bold commentary">{{
											mission.commentary
										}}</vs-td>
										<vs-td class="pdl0">
											<div style="display: flex; justify-content: center">
												<div
													class="vx-row center-content"
													v-if="mission.missions_users"
												>
													<div
														class="flex center"
														v-for="(user, indexx) in mission.missions_users"
														:key="indexx"
													>
														<vx-tooltip text="" color="primary">
															<img
																class="borderRadius10"
																style="height: 25px; width: 25px"
																:src="getColaboratorAvatar(user.user_id)"
															/>
															<template #tooltip>
																<p>
																	{{ getColaboratorName(user.user_id) }}
																</p>
															</template>
														</vx-tooltip>
													</div>
												</div>
											</div>
										</vs-td>
										<vs-td class="fw-bold">{{ mission.recurrence }}</vs-td>
										<vs-td class="pdl0">
											<span class="fw-bold font-medium-4">{{
												roundBudget(mission.max_budget)
											}}</span>
										</vs-td>
										<vs-td class="fw-bold">
											<span class="fw-bold font-medium-4">{{
												roundBudget(mission.max_budget - mission.spent_budget)
											}}</span>
										</vs-td>
										<vs-td class="fw-bold">
											<span
												class="fw-bold font-medium-4"
												:class="{
													'text-danger':
														mission.spent_budget > mission.max_budget,
												}"
												>{{ roundBudget(mission.spent_budget) }}</span
											>
										</vs-td>
										<vs-td class="pdl0">
											<div class="text-center">{{ mission.start_date }}</div>
										</vs-td>
										<vs-td class="pdl0">
											<div class="text-center">{{ mission.end_date }}</div>
										</vs-td>
										<vs-td class="pdl0">
											<div style="display: flex; justify-content: center">
												<vs-chip
													class="product-order-status"
													:color="getContractStatusColor(mission.status)"
													>{{ getContractStatus(mission.status) }}</vs-chip
												>
											</div>
										</vs-td>
										<vs-td v-if="selectedDate" class="pdl0 text-center">
											<Slider
												v-if="
													mission.tasks.find(
														(t) =>
															t.creation_date.substr(0, 7) ==
															selectedDate.split('/').reverse().join('-')
													)
												"
												v-model="
													mission.tasks.find(
														(t) =>
															t.creation_date.substr(0, 7) ==
															selectedDate.split('/').reverse().join('-')
													).archivate
												"
												:id1="
													mission.tasks.find(
														(t) =>
															t.creation_date.substr(0, 7) ==
															selectedDate.split('/').reverse().join('-')
													).id + 'off'
												"
												:id2="
													mission.tasks.find(
														(t) =>
															t.creation_date.substr(0, 7) ==
															selectedDate.split('/').reverse().join('-')
													).id + 'null'
												"
												:id3="
													mission.tasks.find(
														(t) =>
															t.creation_date.substr(0, 7) ==
															selectedDate.split('/').reverse().join('-')
													).id + 'on'
												"
												styleSld="font-size: 10px; background-color: rgba(224, 224, 224, 0.78);width: 165px;"
												styleOp1="color: black; background-color: #FF0000; width:55px; padding: 5px 10px;"
												styleOp2="color: black; background-color: #FFA800; width:55px; padding: 5px 10px;"
												styleOp3="color: black; background-color: #52c41a; width:55px; padding: 5px 10px;"
												opt1="Non fait"
												opt2="Partiellement"
												opt3="Fait"
												@btn-selected="
													updateTask(
														mission.tasks.find(
															(t) =>
																t.creation_date.substr(0, 7) ==
																selectedDate.split('/').reverse().join('-')
														),
														$event
													)
												"
											/>
										</vs-td>
										<!-- <vs-td class="pdl0" @click.stop="event.stopPropagation()">
											<vx-tooltip text="Ajouter" color="success">
												<vs-button
													@click="displayNewPurchasePopup(contract)"
													type="flat"
													icon-pack="feather"
													icon="icon-plus-circle"
												></vs-button>
											</vx-tooltip>
										</vs-td> -->
									</vs-tr>
									<tr
										v-if="expandedMissions[index + '-' + index1]"
										:key="'expand-mission-' + index + '-' + index1"
										class="expand-row"
									>
										<td colspan="13">
											<div class="vx-row" style="width: inherit">
												<vs-tr
													v-if="mission.addMode"
													class="w-full flex"
													style="
														justify-content: space-around;
														align-items: center;
														flex-flow: wrap;
													"
												>
													<vs-td
														style="
															text-align: center;
															width: 100%;
															max-width: 150px;
														"
														class="pdl0"
													>
														<vs-select
															v-model="mission.provider_id"
															class="w-full select-medium mr-2"
															placeholder="Prestataire"
														>
															<vs-select-item
																:key="index"
																:value="item.id"
																:text="item.society"
																v-for="(item, index) in netlinkProviders"
																class="w-full"
															/>
														</vs-select>
													</vs-td>
													<vs-td class="pdl0">
														<vs-input
															v-model="mission.url_bought"
															placeholder="Lien acheté"
															@change="refreshAddLine(contract.id, index1, 2)"
														/>
													</vs-td>
													<vs-td class="pdl0">
														<vs-input
															v-model="mission.landing_page"
															placeholder="Landing page"
															@change="refreshAddLine(contract.id, index1, 3)"
														/>
													</vs-td>
													<vs-td class="pdl0">
														<vs-select
															v-model="mission.anchor_type"
															class="w-full select-medium mr-2"
														>
															<vs-select-item
																:key="index"
																:value="item.value"
																:text="item.text"
																v-for="(item, index) in anchorTypes"
																class="w-full"
															/>
														</vs-select>
													</vs-td>
													<vs-td class="pdl0">
														<vs-select
															v-model="mission.link_type"
															class="w-full select-medium mr-2"
														>
															<vs-select-item
																:key="index"
																:value="item.id"
																:text="item.name"
																v-for="(item, index) in netlinkTypes"
																class="w-full"
															/>
														</vs-select>
													</vs-td>
													<vs-td class="pdl0">
														<vs-input
															v-model="mission.netlink_price"
															placeholder="Prix"
															@change="refreshAddLine(contract.id, index1, 6)"
														/>
													</vs-td>
													<vs-td class="pdl0">
														<date-picker
															v-model="mission.creation_date"
															format="DD/MM/YYYY"
															class="w-full"
														></date-picker>
													</vs-td>
													<vs-td class="pdl0">
														<vs-select
															v-model="mission.status"
															class="w-full select-medium mr-2"
														>
															<vs-select-item
																:key="index"
																:value="item.value"
																:text="item.text"
																v-for="(item, index) in contractStatus"
																class="w-full"
															/>
														</vs-select>
													</vs-td>
													<vs-td class="text-center">
														<vx-tooltip text="Ajouter" color="success">
															<vs-button
																@click="
																	addNetlink(contract.id, index1, mission)
																"
																type="flat"
																color="success"
																icon-pack="feather"
																icon="icon-plus-circle"
															></vs-button>
														</vx-tooltip>
														<vx-tooltip text="Annuler" color="danger">
															<vs-button
																@click="
																	mission.addMode = false;
																	initMissionForNetlink(mission);
																"
																type="flat"
																color="danger"
																icon-pack="feather"
																icon="icon-trash"
															></vs-button>
														</vx-tooltip>
													</vs-td>
												</vs-tr>
												<vs-table
													:data="mission.netlinks"
													auto-resize
													class="w-full thead-2"
													noDataText="Aucune netlink"
												>
													<template slot="thead">
														<vs-th sort-key="url_bought">Lien acheté</vs-th>
														<vs-th sort-key="landing_page" class="pdl0"
															>Landing page</vs-th
														>
														<vs-th sort-key="anchor_type" class="pdl0"
															>Type Ancre</vs-th
														>
														<vs-th sort-key="link_type" class="pdl0"
															>Type Lien</vs-th
														>
														<vs-th sort-key="netlink_price"
															><div class="w-full text-right">ACHAT</div></vs-th
														>
														<vs-th sort-key="creation_date" class="pdl0"
															><div class="w-full text-center">
																DATE<br />CRÉATION
															</div></vs-th
														>
														<vs-th sort-key="status"
															><div class="w-full text-center">
																STATUT
															</div></vs-th
														>
														<vs-th></vs-th>
													</template>
													<template slot-scope="{ data }">
														<vs-tr
															:key="index2 + refreshNetlink"
															v-for="(oneNetlink, index2) in data"
															:id="oneNetlink.id"
														>
															<vs-td
																:data="oneNetlink.url_bought"
																v-if="!oneNetlink.edit"
																><a
																	class="hvr-underline hvr-underline-out"
																	:href="oneNetlink.url_bought"
																	target="_blank"
																	>{{ oneNetlink.url_bought }}</a
																></vs-td
															>
															<vs-td :data="oneNetlink.url_bought" v-else>
																<vs-input
																	v-model="oneNetlink.url_bought"
																	placeholder="Lien acheté"
																/>
															</vs-td>
															<vs-td
																:data="oneNetlink.landing_page"
																class="pdl0"
																v-if="!oneNetlink.edit"
																><a
																	class="hvr-underline hvr-underline-out"
																	:href="oneNetlink.landing_page"
																	target="_blank"
																	>{{ oneNetlink.landing_page }}</a
																></vs-td
															>
															<vs-td
																:data="oneNetlink.landing_page"
																class="pdl0"
																v-else
															>
																<vs-input
																	v-model="oneNetlink.landing_page"
																	placeholder="Landing page"
																/>
															</vs-td>
															<vs-td
																:data="oneNetlink.anchor_type"
																class="pdl0"
																>{{
																	getAnchorType(oneNetlink.anchor_type)
																}}</vs-td
															>
															<vs-td
																:data="oneNetlink.link_type"
																class="pdl0"
																>{{
																	getNetlinkType(oneNetlink.link_type)
																}}</vs-td
															>
															<vs-td
																:data="oneNetlink.netlink_price"
																class="text-right pdl0"
																>{{ oneNetlink.netlink_price }}</vs-td
															>
															<vs-td
																:data="oneNetlink.creation_date"
																class="pdl0"
																>{{ oneNetlink.creation_date }}</vs-td
															>
															<vs-td
																:data="oneNetlink.status"
																class="text-center pdl0"
															>
																<vs-chip
																	class="product-order-status"
																	:color="
																		getContractStatusColor(oneNetlink.status)
																	"
																	>{{
																		getContractStatus(oneNetlink.status)
																	}}</vs-chip
																>
															</vs-td>
															<vs-td class="text-center">
																<vx-tooltip
																	v-if="!oneNetlink.edit"
																	text="Modifier"
																	color="primary"
																>
																	<vs-button
																		@click="
																			oneNetlink.edit = true;
																			oneNetlink.tmpUrlBought =
																				oneNetlink.url_bought;
																			oneNetlink.tmpLandingPage =
																				oneNetlink.landing_page;
																			refreshNetlink++;
																		"
																		size="large"
																		color="primary"
																		type="flat"
																		icon-pack="feather"
																		icon="icon-edit-3"
																	></vs-button>
																</vx-tooltip>
																<vx-tooltip
																	v-if="oneNetlink.edit"
																	text="Sauvegarder"
																	color="success"
																>
																	<vs-button
																		@click="
																			modifyNetlink(contract.id, index1, index2)
																		"
																		size="large"
																		color="success"
																		type="flat"
																		icon-pack="feather"
																		icon="icon-save"
																	></vs-button>
																</vx-tooltip>
																<vx-tooltip
																	v-if="!oneNetlink.edit"
																	text="Supprimer"
																	color="danger"
																>
																	<vs-button
																		@click="
																			showConfirmationPopup = true;
																			selectedNetlink = oneNetlink;
																		"
																		size="large"
																		color="danger"
																		type="flat"
																		icon-pack="feather"
																		icon="icon-trash-2"
																	></vs-button>
																</vx-tooltip>
																<vx-tooltip
																	v-if="oneNetlink.edit"
																	text="Annuler"
																	color="danger"
																>
																	<vs-button
																		@click="
																			oneNetlink.edit = false;
																			oneNetlink.url_bought =
																				oneNetlink.tmpUrlBought;
																			oneNetlink.landing_page =
																				oneNetlink.tmpLandingPage;
																			refreshNetlink--;
																		"
																		size="large"
																		color="danger"
																		type="flat"
																		icon-pack="feather"
																		icon="icon-trash-2"
																	></vs-button>
																</vx-tooltip>
															</vs-td>
														</vs-tr>
													</template>
												</vs-table>
											</div>
										</td>
									</tr>
								</template>
							</vs-table>
						</div>
					</td>
				</tr>
			</template>
		</vs-table>
	</div>
</template>

<script>
import Vue from "vue";
import moment from "moment";
import store from "@/store/store";
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import utilsMixin from "@/mixins/utilsMixin.js";
import Netlink from "@/entities/Netlink";
import Purchase from "@/entities/Purchase";
import BudgetDetailPopup from "@/components/popups/BudgetDetailPopup";
import ContractInfoPopup from "@/components/popups/ContractInfoPopup";
import HistoricalPurchasesPopup from "@/components/popups/HistoricalPurchasesPopup";
import NewNetlinkForContractPopup from "@/components/popups/NewNetlinkForContractPopup";
import LinkPopup from "@/components/popups/NetlinkInfoPopup";
import SocietyInfoPopup from "@/components/popups/SocietyInfoPopup";
import ShareLinkPopup from "@/components/popups/ShareLinkPopup";
import TaskHistoryPopup from "@/components/popups/TaskHistoryPopup";
import Slider from "@/components/widgets/SliderWith3btn";
import Validator from "@/entities/Validator";
import VueCookies from "vue-cookies";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import monthSelect from "flatpickr/dist/plugins/monthSelect";
import "flatpickr/dist/plugins/monthSelect/style.css";
// import XLSX from "xlsx";

export default {
	name: "GestionConsultantsNetlinkingTable",
	props: {
		contracts: Array,
		selectedDate: String,
		refreshKey: Number,
		isLoading: Boolean,
	},
	mixins: [dbFieldConvertor, utilsMixin],
	components: {
		Slider,
		BudgetDetailPopup,
		ContractInfoPopup,
		HistoricalPurchasesPopup,
		LinkPopup,
		NewNetlinkForContractPopup,
		ShareLinkPopup,
		SocietyInfoPopup,
		TaskHistoryPopup,
		flatPickr,
		monthSelect,
	},
	computed: {
		activeUser: () => {
			return VueCookies.get("userInfo");
		},
		diffMonth: () => {
			return store.getters.getFilterMonthDiff;
		},

		allCollaborators: () => {
			return store.state.collaborators;
		},
		allCollaboratorsAvatar: () => {
			return store.state.collaborators_avatar;
		},
		allContractsWithContractsUsers: () => {
			return store.state.contracts_contracts_users;
		},
		dns: () => {
			return store.state.dns;
		},
		netlinks: () => {
			return store.state.netlink;
		},
		netlink_types: () => {
			return store.state.netlink_types;
		},
		products_categories: () => {
			return store.state.products_categories.map((row) => row.name);
		},
		providers: () => {
			return store.state.providers;
		},
		services: () => {
			return store.state.services;
		},
		societies: () => {
			return store.state.societies;
		},
		tasks: () => {
			return store.state.tasks;
		},
	},
	data() {
		return {
			rowNum: 0,
			allContracts: [],
			basicImgUrl: "favicon.png",
			apiUrl: this.$store.state.backendApiUrl,
			apiErrorMsg: null, // catching api error message
			selectedContract: null,
			selectedSociety: null,
			showBudgetPopup: false,
			showConfirmationPopup: false,
			showContractPopup: false,
			showDocPopup: false,
			showHistoryPopup: false,
			showLinkPopup: false,
			showLinkEditPopup: false,
			showNewPurchasePopup: false,
			showSocietyPopup: false,
			societyList: [],
			societyImageList: [],
			tmpContractId: null,
			modifiedNetlink: Netlink.getFormFields(),
			validators: [],
			anchorTypes: [
				{ text: "Brand et Générique", value: 0 },
				{ text: " Semi optimisée", value: 1 },
				{ text: "Générique", value: 2 },
				{ text: "Non optimisée", value: 3 },
				{ text: "Optimisée", value: 4 },
			],
			billableOptions: [
				{ text: "Non", value: 1 },
				{ text: "Oui", value: 2 },
			],
			netlinkStatus: [
				{ text: "Actif", value: 0 },
				{ text: "En attente", value: 1 },
				{ text: "Refusé", value: 2 },
				{ text: "Terminé", value: 3 },
				{ text: "En cours de rédaction", value: 4 },
				{ text: "Annulé", value: 5 },
			],
			renewDurations: [
				{ text: "A vie", value: 0 },
				{ text: "Mensuel", value: 1 },
				{ text: "Annuel", value: 12 },
			],
			//DocPopup
			societyId: null,
			societyName: null,
			contractId: null,
			productName: null,
			missionId: null,
			taskId: null,

			showValidationPopup: false,
			contractToDelete: null,
			showModal: false,
			allDocuments: [],

			//Modification netlink
			society_name: null,
			provider_name: null,
			refreshNetlink: 0,

			//New netlink
			netlinkProviders: [],

			//Expand functionality
			expandedRows: {},
			expandedMissions: {},

			configDatePicker: {
				locale: require("flatpickr/dist/l10n/fr.js").default.fr,
				plugins: [
					new monthSelect({
						shorthand: true,
						dateFormat: "m/Y",
						altFormat: "m-Y",
						theme: "light",
					}),
				],
			},
		};
	},
	beforeCreate() {
		this.$store.dispatch("getAllNetlink");
		this.$store.dispatch("getAllTasks");
		this.$store.dispatch("getAllContractsWithContractsUsers");
		this.$store.dispatch("getAllNetlinkTypes");
		this.$store.dispatch("getAllCollaboratorsAvatar");
		this.$store.dispatch("getAllCollaborators");
		this.$store.dispatch("getAllProviders");
		this.$store.dispatch("getAllServices");
		this.$store.dispatch("getAllSocieties");
		this.$store.dispatch("getAllProductsCategories");
		this.$store.dispatch("getAllDns");
		this.$emit("getData");
	},
	created() {
		this.createNetlinkProviderList();
		console.log("lol", this.$props.contracts);
	},
	watch: {
		contracts: async function (data) {
			this.allContracts = [...data];
			if (this.allContracts.length == 0) this.rowNum = 0;
			//console.log("societyList data", this.allContracts);
			this.societyList = [];
			for (let row of data) {
				if (!this.societyList.includes(row.society_id))
					this.societyList.push(row.society_id);
			}
			//console.log("societyList", this.societyList);
			let queries = [];
			for (let i = 0; i < this.societyList.length; i++) {
				queries.push(this.getSocietyImage(String(this.societyList[i])));
			}
			await Promise.all(queries);
			this.$emit("refresh-key");
		},
	},
	updated() {
		this.expandAll();
		this.createNetlinkProviderList();
	},
	methods: {
		createNetlinkProviderList() {
			//Find Netlink service id
			let netlinkService = this.services.find(
				(service) => service.name == "Netlinking"
			);
			//Filter Providers on service id
			let netlinkProviderList = [];
			if (netlinkService) {
				netlinkProviderList = this.providers.filter((provider) =>
					provider.service_id_list
						? provider.service_id_list
								.split(",")
								.indexOf(netlinkService.id.toString()) >= 0
						: false
				);
			}
			this.netlinkProviders = netlinkProviderList;
		},

		// TODO
		getTotalBudgetMax(contractList) {
			let startDateFilter = store.getters.getFiltersFields["start_date"];
			let endDateFilter = store.getters.getFiltersFields["end_date"];
			//checking if they has been initalised by user or not
			let startDateConv = startDateFilter
				? startDateFilter.split("/").reverse().join("-") + "-01"
				: "";
			let endDateConv = endDateFilter
				? endDateFilter.split("/").reverse().join("-") + "-01"
				: "";
			let budgetMax = 0;
			// //console.log("contractList", contractList);
			contractList.missions.forEach((mission) => {
				//checking if mission satrt date is nnull or not if null assgin to filter date and if not check thier superiority
				let startMark =
					mission.start_date == null
						? startDateConv == ""
							? moment().format("YYYY-MM-DD")
							: startDateConv // mission date is null ->  keep today defaut date || use filter date
						: startDateConv == ""
						? mission.start_date
						: new Date(mission.start_date).getTime() >
						  new Date(startDateConv).getTime()
						? mission.start_date
						: startDateConv; // mission date is not null -> if filter date is null pass to mission date if not check superioty
				let endMark =
					mission.estimated_end_date == null
						? endDateConv == ""
							? moment().format("YYYY-MM-DD")
							: endDateConv
						: endDateConv == ""
						? mission.estimated_end_date
						: new Date(mission.estimated_end_date.substr(0, 9)).getTime() <
						  new Date(endDateConv).getTime()
						? mission.estimated_end_date
						: endDateConv;
				////console.log(this.getAbsoluteMonths(moment(endMark)) - this.getAbsoluteMonths(moment(startMark)), mission.max_budget);
				budgetMax +=
					((this.getAbsoluteMonths(moment(endMark)) -
						this.getAbsoluteMonths(moment(startMark)) || 0) +
						1) *
					mission.max_budget;
			});
			return budgetMax;
		},
		getAbsoluteMonths(momentDate) {
			var months = Number(momentDate.format("MM"));
			var years = Number(momentDate.format("YYYY"));
			return months + years * 12;
		},

		validateNetlinkInline(netlink) {
			let regex = /^https?:\/\/(?!.*:\/\/)\S+/;
			let priceRegex = new RegExp(/^\d+(\.\d{1,2}|\,\d{1,2})?$/);
			let urlBought = regex.test(netlink.url_bought);
			let landingPage = regex.test(netlink.landing_page);
			if (!urlBought || !landingPage) {
				if (!urlBought) netlink.url_bought = netlink.tmpUrlBought;
				if (!landingPage) netlink.landing_page = netlink.tmpLandingPage;
				this.$vs.notify({
					title: "Erreur",
					text: "Veuillez saisir une URL valide (http(s)://domain.com)",
				});
			} else if (
				netlink.netlink_price &&
				!priceRegex.test(netlink.netlink_price)
			) {
				this.$vs.notify({
					title: "Erreur",
					text: "Le prix doit être un nombre.",
				});
			}
			// else this.updateNetlinkInline(netlink);
		},

		updateNetlinkInline(netlink) {
			netlink.netlink_price = Number(netlink.netlink_price.replace(",", "."));
			let today = new Date(Date.now());
			let formatedDate = today.toISOString().substring(0, 10);
			formatedDate = formatedDate.split("/").reverse().join("-");
			formatedDate = formatedDate + " 02:00:00";
			let formatedNetlinkPrice =
				netlink.netlink_price instanceof String
					? Number(netlink.netlink_price.replace(",", "."))
					: netlink.netlink_price;
			this.$http
				.post(this.apiUrl + "netlink/edit", {
					id: netlink.id,
					urlBought: netlink.url_bought,
					anchorType: netlink.anchor_type,
					landingPage: netlink.landing_page,
					status: netlink.status,
					linkType: netlink.link_type,
					domainAuthority: netlink.domain_authority,
					pageAuthority: netlink.page_authority,
					trustFlow: netlink.trust_flow,
					citationFlow: netlink.citation_flow,
					externalLinks: netlink.external_links,
					refDomains: netlink.refDomains,
					purchase_id: netlink.purchase_id,
					society_id: netlink.society_id,
					creation_date: netlink.creation_date.replace(/T|Z/g, " "),
					dns_id: netlink.dns_id,
					contract_id: netlink.contract_id,
					renew_duration: netlink.renew_duration,
					renew_date: formatedDate,
					price: formatedNetlinkPrice,
				})
				.then((result) => {
					//console.log("netlink/editpn", netlink.purchase_id);
					//console.log("netlink/editpn", netlink.id);
					//console.log("netlink/editpn", formatedNetlinkPrice);
					this.$http
						.post(this.apiUrl + "netlink/editpn", {
							purchase_id: netlink.purchase_id,
							netlink_id: netlink.id,
							price: formatedNetlinkPrice,
						})
						.then((res) => {
							if (res)
								this.$vs.notify({
									title: "Succes",
									text: "L'achat mis à jour.",
								});
							netlink.edit = false;
							this.refreshNetlink--;
							this.$emit("refresh-data");
						})
						.catch((err) => {
							if (err)
								this.$vs.notify({
									title: "Erreur",
									text: "Cet achat n'a pas été mis à jour.",
								});
							//console.log(err);
						});
					if (result)
						this.$vs.notify({ title: "Succes", text: "Netlink mis à jour." });
				})
				.catch((error) => {
					if (error)
						this.$vs.notify({
							title: "Erreur",
							text: "Ce netlink n'a pas été mis à jour.",
						});
					//console.log(error);
				});
		},
		expandAll() {
			try {
				let th = document.querySelector("th.td-check");
				if (th && th.innerHTML == "<!---->") {
					th.innerHTML =
						'<button id="expandAll" class="extrue"><i class="vs-icon notranslate icon-scale material-icons null">keyboard_arrow_down</i></button>';
					th.addEventListener("click", () => {
						if (
							th.innerHTML ==
							'<button id="expandAll" class="extrue"><i class="vs-icon notranslate icon-scale material-icons null">keyboard_arrow_down</i></button>'
						) {
							for (let line of this.$refs.switch) {
								if (!line.expanded) line.$el.click();
							}
							th.innerHTML =
								'<button id="expandAll" class="exfalse"><i class="vs-icon notranslate icon-scale material-icons null">keyboard_arrow_down</i></button>';
						} else {
							for (let line of this.$refs.switch) {
								if (line.expanded) line.$el.click();
							}
							th.innerHTML =
								'<button id="expandAll" class="extrue"><i class="vs-icon notranslate icon-scale material-icons null">keyboard_arrow_down</i></button>';
						}
					});

					for (let line of this.$refs.switch) {
						line.$el.addEventListener("click", () => {
							if (
								line.expanded &&
								th.innerHTML ==
									'<button id="expandAll" class="extrue"><i class="vs-icon notranslate icon-scale material-icons null">keyboard_arrow_down</i></button>'
							) {
								th.innerHTML =
									'<button id="expandAll" class="exfalse"><i class="vs-icon notranslate icon-scale material-icons null">keyboard_arrow_down</i></button>';
							}
							if (
								!line.expanded &&
								th.innerHTML ==
									'<button id="expandAll" class="exfalse"><i class="vs-icon notranslate icon-scale material-icons null">keyboard_arrow_down</i></button>'
							) {
								th.innerHTML =
									'<button id="expandAll" class="extrue"><i class="vs-icon notranslate icon-scale material-icons null">keyboard_arrow_down</i></button>';
							}
						});
					}
				}
			} catch (err) {
				console.log("Error in expandAll", err.toString());
			}
		},
		refreshAddLine(contractId, index, nb) {
			if (!this.$refs["switchMission" + contractId][index].expanded)
				this.$refs["switchMission" + contractId][index].$el.click();
			this.$nextTick(() => {
				this.$refs["switchMission" + contractId][index].$el.click();
				this.$nextTick(() => {
					if (!this.$refs["switchMission" + contractId][index].expanded)
						this.$refs["switchMission" + contractId][index].$el.click();
				});
			});
			if (nb == 3) this.$refs["switchMission" + contractId][index].$el.click();
			this.$nextTick(() => {
				if (!this.$refs["switchMission" + contractId][index].expanded)
					this.$refs["switchMission" + contractId][index].$el.click();
			});
		},
		resetNewNetlink(addMode, mission) {
			if (!addMode) {
				mission["url_bought"] = null;
				mission["landing_page"] = null;
				mission["netlink_price"] = 0;
				mission["netlink_status"] = null;
				mission["provider_id"] = null;
				mission["anchor_type"] = null;
				mission["link_type"] = null;
			}
		},

		getNetlinkTypeName(netlinkTypeId) {
			let foundNetlinkType = this.netlink_types.findIndex(
				(row) => row.id == netlinkTypeId
			);
			if (foundNetlinkType >= 0)
				return this.netlink_types[foundNetlinkType].name;
			else " ";
		},
		getProviderIdToName(provider_id) {
			let provider_name = "";
			let provider = this.providers.find(
				(provider) => provider.id == provider_id
			);
			if (provider != undefined && provider.society != undefined) {
				provider_name = provider.society;
			}
			return provider_name;
		},
		getServiceIdToName(service_id) {
			let service_name = "";
			let service = this.services.find((service) => service.id == service_id);
			if (service != undefined && service.name != undefined) {
				service_name = service.name;
			}
			return service_name;
		},
		setSocietyImage(societyId) {
			let foundImage = this.societyImageList.find(
				(society) => society.id == societyId
			);
			if (foundImage) return foundImage.image;
			else return this.basicImgUrl;
		},
		/**
		 * Fetch image if society.image is true else return false
		 * @param {Society} society - The society from which image is requested
		 */
		getSocietyImage(society) {
			return new Promise((resolve, reject) => {
				this.$http
					.get(this.apiUrl + "society/getImg/" + society + "/small")
					.then((image) => {
						if (image.data) {
							this.societyImageList.push({
								id: society,
								image: image.data,
							});
						}
						resolve(true);
						// this.testImage = image.data;
					})
					.catch((err) => {
						//console.log(err);
						reject(err);
					});
			});
		},
		getSocietyName(societyId) {
			for (let society of this.societies) {
				if (societyId == society.id) {
					return society.name;
				}
			}
			return "Entreprise non renseignée";
		},

		accept() {
			this.deleteDoc(this.docId);
			this.showConfirmationPopup = false;
		},
		validateOne(val, name) {
			let value = val;
			value == 0 ? (value = "0") : "";
			let constname = "";
			switch (name) {
				case "price":
					value ? (value = String(val)) : "";
					constname = "priceConstraint";
					break;
				case "url_bought":
				case "landing_page":
					constname = "websiteConstraint";
					break;
				default:
					value ? (value = String(val)) : "";
					value == null ? (value = "") : "";
					constname = "isNumberConstraint";
					break;
			}
			this.validators[name] = new Validator({ constraintName: constname });
			this.validators[name].check(value);
			val == null ? this.validators[name].valid == false : "";
			this.validators[name].valid == false &&
			this.validators[name].errText == ""
				? (this.validators[name].errText = "Ce champ ne peut être vide.")
				: "";
			this.validators[name].valid == false &&
			this.validators[name].errText !== ""
				? (this.check = false)
				: "";
			this.$forceUpdate();
		},
		errText(name) {
			if (this.validators[name] && this.validators[name].errText !== "") {
				return this.validators[name].errText;
			}
		},
		styleValidator(name) {
			if (
				this.validators &&
				this.validators[name] &&
				this.validators[name].valid == false &&
				this.validators[name].errText !== ""
			) {
				return "display: inline-block; border: 1px solid red !important; border-radius: 5px; width: calc(100% - 30px) !important;";
			} else if (
				this.validators &&
				this.validators[name] &&
				this.validators[name].errText == ""
			) {
				return "display: inline-block; border: 1px solid green !important; border-radius: 5px;";
			} else {
				return "display: inline-block; border: none !important; border-radius: none;";
			}
		},

		saveModifiedNetlink() {
			this.check = true;
			let fields = [
				"url_bought",
				"landing_page",
				"status",
				"anchor_type",
				"link_type",
				"price",
				"renew_duration",
			];
			let constname = "";

			for (let i = 0; i < fields.length; i++) {
				let value = this.modifiedNetlink[fields[i]];
				value == 0 ? (value = "0") : "";
				switch (fields[i]) {
					case "url_bought":
					case "landing_page":
						constname = "websiteConstraint";
						break;
					case "price":
						value ? (value = String(value)) : "";
						constname = "priceConstraint";
						break;
					default:
						value ? (value = String(value)) : "";
						value == null ? (value = "") : "";
						constname = "isNumberConstraint";
						break;
				}
				this.validators[fields[i]] = new Validator({
					constraintName: constname,
				});
				this.validators[fields[i]].check(value);
				this.modifiedNetlink[fields[i]] == null
					? (this.validators[fields[i]].valid = false)
					: "";
				this.validators[fields[i]].valid == false &&
				this.validators[fields[i]].errText == ""
					? (this.validators[fields[i]].errText = "Ce champ ne peut être vide.")
					: "";
				if (
					fields[i] == "renew_duration" &&
					!this.isRecurringLink(this.modifiedNetlink.link_type)
				) {
					this.modifiedNetlink.renew_duration = null;
					this.validators[fields[i]].valid = true;
				}
				if (this.isFromNDD == 1) {
					if (
						fields[i] == "renew_duration" ||
						fields[i] == "link_type" ||
						fields[i] == "price"
					) {
						this.modifiedNetlink.renew_duration = null;
						this.modifiedNetlink.link_type = null;
						this.modifiedNetlink.price = null;
						this.validators[fields[i]].valid = true;
					}
				}
				if (this.isFromNDD == 0) {
					if (fields[i] == "newNetlinkDns") {
						this.newNetlinkDns = null;
						this.validators[fields[i]].valid = true;
					}
				}
				this.validators[fields[i]].valid == false &&
				this.validators[fields[i]].errText !== ""
					? (this.check = false)
					: "";
			}

			this.$forceUpdate();

			if (this.check == false) {
				this.$vs.notify({
					title: "Echec",
					text: "Veuillez remplir tous les champs correctement.",
				});
				return false;
			} else {
				this.modifiedNetlink.netlink_price = String(
					this.modifiedNetlink.netlink_price
				).replace(",", ".");
				this.modifiedNetlink.netlink_price = Number(
					this.modifiedNetlink.netlink_price
				);

				let re = new RegExp("([T|Z])", "g");
				this.modifiedNetlink.creation_date =
					this.modifiedNetlink.creation_date.replace(re, " ");

				let params = {
					id: this.modifiedNetlink.id,
					urlBought: this.modifiedNetlink.url_bought,
					anchorType: this.modifiedNetlink.anchor_type,
					landingPage: this.modifiedNetlink.landing_page,
					status: this.modifiedNetlink.status,
					linkType: this.modifiedNetlink.link_type,
					domainAuthority: this.modifiedNetlink.domain_authority,
					pageAuthority: this.modifiedNetlink.page_authority,
					trustFlow: this.modifiedNetlink.trust_flow,
					citationFlow: this.modifiedNetlink.citation_flow,
					externalLinks: this.modifiedNetlink.external_links,
					refDomains: this.modifiedNetlink.ref_domains,
					purchase_id: this.modifiedNetlink.purchase_id,
					society_id: this.modifiedNetlink.society_id,
					creation_date: this.modifiedNetlink.creation_date,
					recurring_purchase_id: this.modifiedNetlink.recurring_purchase_id,
					dns_id: this.modifiedNetlink.dns_id,
					contract_id: this.modifiedNetlink.contract_id,
					price: this.modifiedNetlink.netlink_price,
					renew_duration: this.modifiedNetlink.renew_duration,
					renew_date: this.modifiedNetlink.renew_date,
					editMain: true,
					provider_id: this.modifiedNetlink.provider_id,
				};

				let savedModifiedNetlink = new Netlink(params);
				//console.log(savedModifiedNetlink);
				savedModifiedNetlink.update((err, res) => {
					if (err)
						if (res) {
							//console.log(err);
							this.showLinkEditPopup = false;

							this.$vs.notify({
								title: "Succès",
								text: "Netlink modifié avec succès.",
							});

							this.$refs.popupContainer.children[
								this.$refs.popupContainer.children.length - 1
							].__vue__
								.getAllLinks()
								.then(() => {
									for (let contract of this.allContracts) {
										if (
											this.modifiedNetlink.contract_id == contract.contract_id
										) {
											contract.waiting_netlink_count =
												this.$refs.popupContainer.children[
													this.$refs.popupContainer.children.length - 1
												].__vue__.list.filter(
													(link) => link.status == 1
												).length;
											this.$forceUpdate();
											break;
										}
									}
								});
						}
				});
			}
		},
		confirmation(param) {
			this.showConfirmationPopup = param[0];
			this.docId = param[1];
		},
		decline() {
			this.docId = "";
			this.showConfirmationPopup = false;
		},

		displayBudgetPopup(contract) {
			this.showBudgetPopup = true;
			let year = this.selectedDate.split("/")[1];
			let month = this.selectedDate.split("/")[0];
			let ComponentClass = Vue.extend(BudgetDetailPopup);
			let budgetPopup = new ComponentClass({
				propsData: {
					popupActive: this.showBudgetPopup,
					router: this.$router,
					apiUrl: this.apiUrl,
					contractId: contract.contract_id,
					year: year,
					month: month,
					societyName: contract.society_name,
					allCollaboratorsAvatar: this.allCollaboratorsAvatar,
					netlink_types: this.netlink_types,
					services: this.services,
					societies: this.societies,
					providers: this.providers,
					isTabNetlink: true,
				},
			});

			budgetPopup.$mount();
			this.$refs.popupContainer.appendChild(budgetPopup.$el);
		},
		displayContractPopup(contract_id) {
			this.selectedContract = null;
			let foundContract = this.allContractsWithContractsUsers.findIndex(
				(row) => row.id == contract_id
			);
			if (foundContract < 0) {
				this.$vs.notify({
					title: "Erreur",
					text: "Contrat introuvable, contactez l'équipe technique.",
				});
				return false;
			}
			let account_manager_avatars = [];
			if (this.allContractsWithContractsUsers[foundContract].account_managers) {
				let contract_account_managers_names =
					this.allContractsWithContractsUsers[foundContract]
						.account_managers !== null
						? this.allContractsWithContractsUsers[
								foundContract
						  ].account_managers.split(", ")
						: [];
				let contract_account_managers = contract_account_managers_names.splice(
					0,
					contract_account_managers_names.length / 2
				);
				for (let i = 0; i < contract_account_managers.length; i++) {
					account_manager_avatars.push({
						name: contract_account_managers_names[i],
						users_id: contract_account_managers[i],
						is_lead:
							this.allContractsWithContractsUsers[foundContract].lead_am ==
							contract_account_managers[i]
								? 1
								: 0,
					});
				}
			}
			this.selectedContract =
				this.allContractsWithContractsUsers[foundContract];
			this.selectedContract.account_manager_avatars = account_manager_avatars;
			this.showContractPopup = true;

			//Instancie la class SocietyInfoPopup pour mount sur la balise div principale
			let ComponentClass = Vue.extend(ContractInfoPopup);
			let contractPopup = new ComponentClass({
				propsData: {
					contract: this.selectedContract,
					popupActive: this.showContractPopup,
					router: this.$router,
				},
			});
			// @modify-contract="modifyContract($event)"
			contractPopup.$mount();
			contractPopup.$on("modify-contract", (contractId) => {
				this.popupActive = false;
				this.modifyContract(contractId);
			});
			contractPopup.$on("modify-missions", (contractId) => {
				this.popupActive = false;
				this.modifyMissions(contractId);
			});
			contractPopup.$on("modify-purchase", (purchase) => {
				this.popupActive = false;
				this.modifyPurchase(purchase);
			});
			contractPopup.$on("renew-purchase", (purchaseId) => {
				this.popupActive = false;
				this.renewPurchase(purchaseId);
			});

			this.$refs.popupContainer.appendChild(contractPopup.$el);
		},

		displaySocietyPopup(societyId) {
			this.selectedSociety = null; // Always reset data before assigning it
			this.selectedSociety = JSON.parse(
				JSON.stringify(this.getSocietyById(societyId))
			);
			this.$http
				.get(this.apiUrl + "society/getImg/" + societyId)
				.then((image) => {
					let imgObject = null;
					if (image.data.length > 0) {
						imgObject = image.data;
					}

					this.selectedSociety.image = imgObject;
				})
				.catch((err) => {
					//console.log(err);
				});

			this.showSocietyPopup = true;

			//Instancie la class SocietyInfoPopup pour mount sur la balise div principale
			let ComponentClass = Vue.extend(SocietyInfoPopup);
			let societyPopup = new ComponentClass({
				propsData: {
					society: this.selectedSociety,
					popupActive: this.showSocietyPopup,
					router: this.$router,
					apiUrl: this.apiUrl,
				},
			});
			societyPopup.$mount();
			this.$refs.popupContainer.appendChild(societyPopup.$el);
		},

		displayHistoryPopup(contract_id, society_id) {
			this.tmpContractId = contract_id;
			this.showHistoryPopup = true;
			//Récupération des tâches liées à la société
			let society_tasks = JSON.parse(JSON.stringify(this.tasks));
			//console.log("society_tasks", society_tasks);
			society_tasks = society_tasks.filter(
				(task) => task.contract_society_id == society_id
			);

			let ComponentClass = Vue.extend(TaskHistoryPopup);
			let historyPopup = new ComponentClass({
				propsData: {
					tasks: society_tasks,
					popupActive: this.showHistoryPopup,
					router: this.$router,
					apiUrl: this.apiUrl,
					store: this.$store,
					contractId: contract_id,
				},
			});
			historyPopup.$mount();
			historyPopup.$on("update:popupActive", () => {
				this.refreshTask();
			});
			this.$refs.popupContainer.appendChild(historyPopup.$el);
		},

		displayLinkPopup(contract_id, society_name) {
			this.showLinkPopup = true;

			let ComponentClass = Vue.extend(LinkPopup);
			let linkPopup = new ComponentClass({
				ref: "linkPopup",
				propsData: {
					popupActive: this.showLinkPopup,
					router: this.$router,
					apiUrl: this.apiUrl,
					contractId: contract_id,
					societyName: society_name,
				},
			});

			linkPopup.$mount();
			linkPopup.$on("modify-netlink", (event) => {
				this.updateNetlink(event);
			});
			this.$refs.popupContainer.appendChild(linkPopup.$el);
		},
		displayNewPurchasePopup(contract) {
			this.showNewPurchasePopup = true;

			let ComponentClass = Vue.extend(NewNetlinkForContractPopup);
			let newNetlinkPopup = new ComponentClass({
				propsData: {
					apiUrl: this.apiUrl,
					popupActive: this.showNewPurchasePopup,
					society_id: contract.society_id,
					selectedContract: contract.contract_id,
					societyName: contract.society_name,

					netlink_types: this.netlink_types,
					products_categories: this.products_categories,
					providers: this.providers,
					services: this.services,
					societies: this.societies,
					dns: this.dns,
				},
			});
			newNetlinkPopup.$mount();
			newNetlinkPopup.$on("refresh-data", () => {
				this.$emit("refresh-data");
			});
			this.$refs.popupContainer.appendChild(newNetlinkPopup.$el);
		},
		getCollaboratorAvatar(userId) {
			let foundAvatar = this.allCollaboratorsAvatar.find(
				(avatar) => avatar.id == userId
			);
			if (foundAvatar) return foundAvatar.avatar;
			else return null;
		},

		getCollaboratorName(userId) {
			let foundCollaborator = this.allCollaborators.find(
				(collaborator) => collaborator.id == userId
			);
			if (foundCollaborator)
				return foundCollaborator.firstname + " " + foundCollaborator.lastname;
			else return null;
		},

		getDate(date) {
			if (date) {
				let arr = {
					"01": "Janvier",
					"02": "Février",
					"03": "Mars",
					"04": "Avril",
					"05": "Mai",
					"06": "Juin",
					"07": "Juillet",
					"08": "Août",
					"09": "Septembre",
					10: "Octobre",
					11: "Novembre",
					12: "Décembre",
				};

				return arr[date.substr(5, 2)] + " " + date.substr(0, 4);
			} else {
				return "";
			}
		},

		getPrice(price, txt) {
			if (price) {
				return this.formatThousandNumb(price) + "€";
			} else if (txt) return txt;
			else return "";
		},

		getProviderNameFromId(provider_id) {
			let foundProvider = this.providers.findIndex(
				(provider) => provider.id == provider_id
			);
			if (foundProvider >= 0) {
				this.provider_name = this.providers[foundProvider].society;
			}
		},

		getSocietyById(societyId) {
			return this.societies.find((society) => society.id == societyId);
		},

		isRecurringLink(link_type) {
			let foundIndex = this.netlink_types.findIndex(
				(row) => row.id == link_type
			);
			if (foundIndex >= 0) {
				if (this.netlink_types[foundIndex].recurrency == 1) return true;
			}
			return false;
		},

		jumpToNetlinking(contract_id, society_id) {
			let endDate;
			let splitSelectedDate = this.selectedDate
				.split("/")
				.map((row) => parseInt(row));

			if ([1, 3, 5, 7, 8, 10, 12].includes(splitSelectedDate[0])) endDate = 31;
			else if ([4, 6, 9, 11].includes(splitSelectedDate[0])) endDate = 30;
			else if (splitSelectedDate[0] == 2) endDate = 28;

			let link = this.$router.resolve({
				name: "netlink",
				query: {
					targetSociety: society_id,
					targetContract: contract_id,
					targetStartDate: "01/" + this.selectedDate,
					targetEndDate:
						endDate + "/" + splitSelectedDate[0] + "/" + splitSelectedDate[1],
				},
			});
			window.open(link.href, "_blank");
		},

		modifyContract(contractId) {
			this.showContractPopup = false;
			this.$router.push({
				name: "update_entity",
				params: {
					contractId: contractId,
					startIndex: 0,
					updateEntityForm: "contracts",
				},
			});
		},

		modifyMissions(contractId) {
			this.showContractPopup = false;
			this.$router.push({
				name: "update_entity",
				params: {
					contractId: contractId,
					startIndex: 1,
					updateEntityForm: "contracts_missions",
				},
			});
		},

		async refreshTask() {
			for (let contract of this.allContracts) {
				if (contract.contract_id == this.tmpContractId) {
					for (let i of contract.missions_list) {
						await this.$http
							.get(this.apiUrl + "task/get/" + i.task_id)
							.then((result) => {
								let task = result.data[0];
								if (i.task_archived == 1 && task.archivate !== 1)
									contract.tasks_done--;
								else if (i.task_archived !== 1 && task.archivate == 1)
									contract.tasks_done++;
								i.task_archived = task.archivate;
							})
							.catch((err) => {
								//console.log(err);
							});
					}
					this.$forceUpdate();
					this.tmpContractId = null;
					break;
				}
			}
		},

		setBudgetColor(budget) {
			if (budget.length == 2 && budget[0] > 0 && budget[1] > 0) {
				if (budget[1] / budget[0] > 1) return "color: red;";
				if (budget[1] / budget[0] <= 1 && budget[1] / budget[0] >= 0.85)
					return "color: green;";
				if (budget[1] / budget[0] < 0.85) return "color: orange;";
			}
		},

		setSolde(solde) {
			if (solde) {
				if (solde > 0) return "+" + Math.round(solde * 100) / 100 + "€";
				else if (solde < 0) return Math.round(solde * 100) / 100 + "€";
				else return "0€";
			} else return null;
		},

		setSoldeColor(solde) {
			if (solde) {
				if (solde > 0) return "color: green;";
				else if (solde < 0) return "color: red;";
				else return null;
			} else return null;
		},

		async validateNetlink(societyId, contractId, mission) {
			let errText = "";
			let check = true;
			if (
				mission.provider_id === null ||
				mission.anchor_type === null ||
				mission.link_type === null ||
				!mission.url_bought ||
				!mission.landing_page ||
				mission.netlink_status === null ||
				mission.renew_duration === null ||
				!mission.period_date ||
				mission.is_billable === null ||
				mission.netlink_price === ""
			) {
				check = false;
				errText += "Veuillez remplir tous les champs. ";
			}
			if (mission.is_billable == 2 && mission.sell_price === "") {
				check = false;
				errText +=
					"Le prix de vente est obligatoire pour un netlink facturable. ";
			}
			let regex = new RegExp(/^https?:\/\/(?!.*:\/\/)\S+/);
			if (mission.url_bought) {
				if (!regex.test(mission.url_bought)) {
					check = false;
					errText +=
						" Lien acheté n'est pas une URL valide (http(s)://domain.com).";
				}
			}
			if (mission.landing_page) {
				if (!regex.test(mission.landing_page)) {
					check = false;
					errText +=
						" Landing page n'est pas une URL valide (http(s)://domain.com).";
				}
			}
			if (
				mission.url_bought &&
				mission.landing_page &&
				regex.test(mission.url_bought) &&
				regex.test(mission.landing_page)
			) {
				let doublons = this.netlinks.filter(
					(n) =>
						new URL(n.url_bought).href == new URL(mission.url_bought).href &&
						new URL(n.landing_page).href == new URL(mission.landing_page).href
				);
				if (doublons.length > 0) {
					check = false;
					errText += " Ce netlink existe déjà.";
				}
			}
			if (mission.netlink_price) {
				let priceRegex = new RegExp(/^\d+(\.\d{1,2}|\,\d{1,2})?$/);
				if (!priceRegex.test(mission.netlink_price)) {
					check = false;
					errText += " Le prix doit être un nombre.";
				}
			}
			if (check) {
				let today = new Date().toISOString().substr(0, 10) + " 02:00:00";
				let newNetlink = Netlink.getFormFields();
				newNetlink.provider_id = mission.provider_id;
				newNetlink.anchorType = mission.anchor_type;
				newNetlink.linkType = mission.link_type;
				newNetlink.status = mission.netlink_status;
				newNetlink.urlBought = mission.url_bought;
				newNetlink.landingPage = mission.landing_page;
				newNetlink.price =
					Number(mission.netlink_price.replace(",", ".")) > 0
						? Number(mission.netlink_price.replace(",", "."))
						: 0;
				newNetlink.society_id = societyId;
				newNetlink.contract_id = contractId;
				newNetlink = new Netlink(newNetlink);
				await newNetlink.create(async (err, res) => {
					if (err)
						if (res) {
							//console.log(err);
							if ([1, 4].includes(mission.netlink_status)) {
								await this.$http
									.post(this.apiUrl + "orders/add", {
										order: {
											contract_id: contractId,
											product_id: mission.products_id,
											brief_text: mission.url_bought,
											billable: mission.is_billable - 1,
											billable_price:
												mission.is_billable == 2
													? Number(mission.sell_price.replace(",", "."))
													: null,
											budget:
												!mission.netlink_price ||
												Number(mission.netlink_price.replace(",", ".")) === 0
													? 0
													: Number(mission.netlink_price.replace(",", ".")),
											period: mission.period_date,
											account_manager_id: null,
											user_id: this.activeUser.id,
											status: 1,
										},
										netlink: true,
									})
									.then(() => {
										mission.addMode = false;
										this.$vs.notify({
											title: "Success",
											text: "Netlink créé avec success.",
										});
										this.$emit("refresh-data");
									})
									.catch((error) => {
										//console.log("Erreur add Netlink -> Commande:", error);
										this.$vs.notify({
											title: "Erreur",
											text: "Netlink créé avec success mais il y a une erreur lors la création de la commande.",
										});
									});
							} else if (
								mission.netlink_status == 0 &&
								Number(mission.netlink_price.replace(",", ".")) > 0
							) {
								store.dispatch("getAllNetlink");
								let netlink_id = Math.max.apply(
									Math,
									this.netlinks.map((n) => {
										return n.id;
									})
								);
								let purchase = Purchase.getFormFields();
								let period = `${mission.period_date
									.split("/")
									.reverse()
									.join("-")}-01 02:00:00`;
								let netlinkService = this.services.find(
									(service) => service.name == "Netlinking"
								);
								purchase.user_id = this.activeUser.id;
								purchase.contract_society_id = societyId;
								purchase.contract_id = contractId;
								purchase.users_id = mission.provider_id;
								purchase.service_id = netlinkService.id;
								purchase.bought_at = today;
								purchase.is_delivered = 0;
								purchase.period_date = period;
								purchase.mission_id = mission.id;
								purchase.provider_id = mission.provider_id;
								purchase.is_billable = mission.is_billable - 1;
								purchase.price = Number(
									mission.netlink_price.replace(",", ".")
								);
								purchase.sell_price =
									mission.is_billable == 2
										? Number(mission.sell_price.replace(",", "."))
										: null;
								await this.$http
									.post(this.apiUrl + "purchase/add", {
										price: this.convertFrenchNumberToInternational(
											purchase.price
										),
										recurrence: purchase.recurrence,
										margin_price: this.convertFrenchNumberToInternational(
											purchase.marginPrice
										),
										margin_rate: purchase.marginRate,
										is_billable: purchase.is_billable,
										sell_price: purchase.sell_price,
										commentary: purchase.commentary,
										bought_at: purchase.bought_at,
										contract_id: purchase.contract_id,
										contract_society_id: purchase.contract_society_id,
										service_id: purchase.service_id,
										is_delivered: purchase.is_delivered,
										recurrence_active: purchase.recurrence,
										user_id: purchase.user_id,
										period_date: period,
										mission_id: purchase.mission_id,
										users_id: purchase.provider_id,
									})
									.then(async (result, errorPurchase) => {
										if (result) {
											this.$http
												.post(this.apiUrl + "netlink/addpn", {
													purchase_id: result.data.insertId,
													netlink_id: netlink_id,
													price: Number(
														mission.netlink_price.replace(",", ".")
													),
												})
												.then((success, errorPurchasesNetlinks) => {
													if (errorPurchasesNetlinks) {
														//console.log("Erreur add Netlink -> Purchases_netlinks:", errorPurchasesNetlinks);
														this.$vs.notify({
															title: "Erreur",
															text: "Netlink créé avec success mais il y a une erreur lors la création de lien purchases_netlinks.",
														});
													} else {
														mission.addMode = false;
														this.$vs.notify({
															title: "Success",
															text: "Netlink créé avec success.",
														});
														this.$emit("refresh-data");
													}
												})
												.catch((errorPurchasesNetlinks) => {
													//console.log("Erreur add Netlink -> Purchases_netlinks:", errorPurchasesNetlinks);
													this.$vs.notify({
														title: "Erreur",
														text: "Netlink créé avec success mais il y a une erreur lors la création de lien purchases_netlinks.",
													});
												});
										}
										if (errorPurchase) {
											//console.log("Erreur add Netlink -> Achat:", errorPurchase);
											this.$vs.notify({
												title: "Erreur",
												text: "Netlink créé avec success mais il y a une erreur lors la création de l'achat.",
											});
										}
									})
									.catch((errorPurchase) => {
										//console.log("Erreur add Netlink -> Achat:", errorPurchase);
										this.$vs.notify({
											title: "Erreur",
											text: "Netlink créé avec success mais il y a une erreur lors la création de l'achat.",
										});
									});
							} else {
								mission.addMode = false;
								this.$vs.notify({
									title: "Success",
									text: "Netlink créé avec success.",
								});
								this.$emit("refresh-data");
							}
						}
				});
			} else {
				this.$vs.notify({ title: "Erreur", text: errText });
			}
		},

		updateNetlink(netlink) {
			this.$http
				.get(this.apiUrl + "purchase/get/" + netlink[0].purchase_id)
				.then((res) => {
					this.getProviderNameFromId(res.data[0].users_id);
				});
			this.modifiedNetlink = null; // Always reset data before assigning it
			this.modifiedNetlink = JSON.parse(JSON.stringify(netlink[0]));
			this.society_name = netlink[1];
			this.showLinkEditPopup = true;
		},

		async updateTask(task, task_state) {
			await this.$http
				.post(this.apiUrl + "task/edit/" + task.id, {
					commentary: task.commentary,
					link: task.link,
					status: task.status,
					creation_date: task.creation_date.substr(0, 10) + " 02:00:00",
					finished_date: new Date().toISOString().substr(0, 10) + " 02:00:00",
					recurrence: task.recurrence,
					frequency: task.frequency,
					archivate: task_state,
					contract_id: task.contract_id,
					contract_society_id: task.contract_society_id,
					mission_id: task.mission_id,
				})
				.then(async (res) => {
					//console.log("resTask", res);
					if (!task.recurrence || task.recurrence == 0) {
						let mission_status = 1;
						if (task_state == 1) {
							mission_status = 7;
						} else if (task_state == 0 || task_state == 2) {
							mission_status = 1;
						}
						await this.$http
							.post(this.apiUrl + "mission/editarch", {
								contract_id: task.contract_id,
								status: mission_status,
								id: task.mission_id,
							})
							.then((res) => {
								//console.log("resMission", res);
								this.$vs.notify({
									title: "Succès",
									text: "Tâche modifiée avec succès.",
								});
								store.dispatch("getAllTasks");
								this.$emit("refresh-task");
							})
							.catch((err) => {
								//console.log(err);
								this.$vs.notify({
									title: "Echec",
									text: "La tâche n'a pas été modifiée.",
								});
							});
					} else {
						this.$vs.notify({
							title: "Succès",
							text: "Tâche modifiée avec succès.",
						});
						this.$emit("update-task", [task, task_state]);
						store.dispatch("getAllTasks");
					}
					this.$forceUpdate();
				})
				.catch((err) => {
					//console.log(err);
					this.$vs.notify({
						title: "Echec",
						text: "La tâche n'a pas été ajoutée.",
					});
				});
		},

		toggleExpand(index) {
			this.$set(this.expandedRows, index, !this.expandedRows[index]);
		},

		toggleMissionExpand(contractIndex, missionIndex) {
			const key = contractIndex + "-" + missionIndex;
			this.$set(this.expandedMissions, key, !this.expandedMissions[key]);
		},
	},
};
</script>

<style lang="scss">
.btn-txt-center > span {
	align-self: center !important;
}
.center {
	justify-content: center;
}
.hvr-underline:hover {
	color: aqua;
	text-decoration: underline;
	cursor: pointer;
}

.th-sticky {
	position: sticky;
	top: 0;
	background-color: inherit;
}
.thead-1 > div > div > table > thead > tr {
	background-color: #0c293d;
	th > div {
		color: white;
	}
}
.thead-2 > div > div > table > thead > tr {
	background-color: rgb(8, 176, 185);
	th > div {
		color: white;
	}
}
th > div > span {
	text-transform: uppercase;
}
th.td-check {
	position: sticky;
	top: 0;
	background-color: inherit;
	pointer-events: auto;
}
#expandAll {
	border: none;
	pointer-events: auto;
	cursor: pointer;
}
.extrue {
	padding-top: 20px;
	padding-right: 10px;
	background: none;
	transform: rotate(-90deg);
}

.exfalse {
	padding-left: 5px;
	background: none;
	transform: rotate(0deg);
}

#tb-gestion-netlink > .con-tablex.vs-table--content {
	overflow: visible;
	overflow-x: auto;
}
#tb-gestion-netlink > div > .vs-con-tbody.vs-table--tbody {
	overflow: auto;
	max-height: 45vh;
}
i {
	align-self: center;
}
.vs-con-tbody.vs-table--tbody {
	height: 100%;
}
.vs-tooltip.vs-tooltip-top.vs-tooltip-null {
	word-break: break-all;
}

.expand-row {
	background-color: #f8f9fa;
	border-left: 4px solid #007bff;
}

.expand-row td {
	padding: 15px !important;
}
</style>
